import React, { Component, useEffect, useState } from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import axios from 'axios';
import Select from "react-select";
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL } from '../../config.js'
import DataTable, { defaultThemes } from 'react-data-table-component';


import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';

import Pagination from '../Pagination/Paginations.js';
import EntriesSelector from '../Pagination/EntriesSelector';
import useSortData from "../Pagination/SortData";

// import DataTable from 'datatables.net-react';
// import DT from 'datatables.net-dt';

// DataTable.use(DT);
import {
	statisticsAction,
	statisticsCloseAction
} from '../../actions/settingsAction.js';
import { Link } from 'react-router-dom/cjs/react-router-dom.min.js';
const InchargeShiftInfo = (props) => {
	const sparkline1 = React.createRef();
	const sparkline2 = React.createRef();
	const sparkline3 = React.createRef();
	const sparkline4 = React.createRef();


	const handleStatistics = (e) => {
		statisticsAction(e)
	}
	const closeStatistics = (e) => {
		statisticsCloseAction(e)
	}

	const { fixNavbar, statisticsOpen, statisticsClose } = props;
	
	
	const today = new Date().toISOString().split("T")[0];


	const [user, setUser] = useState({
        start_date: today,
        end_date: today,
        shift_id:"ALL",
    })



	

	
	const history = useHistory();
	const [data, setData]= useState([]);
	const [dataval, setdataval]= useState([]);
    const [isVisible, setIsVisible] = useState(false);
	const [urlres, setUrlRes] = useState(false);
	const [style1,setStyle1]=useState(false);
	const [records, setRecords] = useState([]);
	const [loading, setLoading] = useState(false);

	const { sortConfig, sortData, handleSort } = useSortData();


    const handelInput = (event) => {
        event.preventDefault();
        const { name, value } = event.target;
        console.log(name, value)
        setUser({ ...user, [name]: value });

        if (event.target.value === '1') {
            setIsVisible(true);
          } else {
            setIsVisible(false);
          }
    }


	const handleSubmit = async (e) => {
    e.preventDefault();

	// alert(user.start_date);
	// alert(user.end_date);
	// alert(department);
	// alert(employeedet);
	setLoading(true);
    try {
      const response = await axios.post(API_BASE_URL +'/inchargeshiftinfo',
		{ start_date: user.start_date, end_date: user.end_date, dept_id: department,user_id: employeedet }, 
		{
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}

);
 console.log(response.data.shiftinfo);
      setRecords(response.data.shiftinfo); // Assuming the API response contains the records in `response.data`
	  setLoading(false);
	} catch (error) {
      console.error("Error fetching data:", error);
	   setRecords([]);
    }
  };


//   useEffect(()=> {
// 	axios.post(API_BASE_URL +'/inchargeshiftinfo',{ start_date: user.start_date, end_date: user.end_date, dept_id:department,employee_id: employeedet }, {
// 		headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
// 	})

// 	 .then(response =>console.log(response))
// 	 .then(response => setRecords(response.data.shiftinfo))
// 	.catch(err => console.log(err));
// },[])


useEffect(() => {
  setLoading(true);

  axios
    .post(
      API_BASE_URL + "/inchargeshiftinfo",
      {
        start_date: user.start_date,
        end_date: user.end_date,
        dept_id: department,
        employee_id: employeedet,
      },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
      }
    )
    .then((res) => {
      setRecords(res.data.shiftinfo || []);
      setLoading(false);
    })
    .catch((err) => {
      console.log(err);
      setLoading(false);
    });
}, []);




		const [searchTerm, setSearchTerm] = useState("");
		const [currentPage, setCurrentPage] = useState(1);
		const [entriesPerPage,setEntriesPerPage]=useState(10);


const searchableFields = [
  "employee_id",
  "employee_name",
  "department_name",
  "shift_code",
  "shift_name",
  "shift_date",
  "day",
];




		const safe = (val) => String(val ?? "").toLowerCase();
		
		const filteredItems =
		  searchTerm.trim() === ""
			? records
			: records.filter((item) =>
				searchableFields.some((field) =>
				  safe(item[field]).includes(searchTerm.toLowerCase())
				)
			  );
		
				const totalPages = Math.ceil(filteredItems.length / entriesPerPage);
				const indexOfLast = currentPage * entriesPerPage;
				const indexOfFirst = indexOfLast - entriesPerPage;
				// const filteredData = filteredItems.slice(indexOfFirst, indexOfLast);
		
				  const sortedItems = sortData(filteredItems);
				  const filteredData = sortedItems.slice(indexOfFirst, indexOfLast);
			  
				useEffect(() => {
				  setCurrentPage(1);
				}, [searchTerm]);
			  
				
			
			  const handleSearch = (event) => {
				//console.log(event.target.value);
				 setSearchTerm(event.target.value);
			  };
		
			  const clearInput = () => {
				setSearchTerm("");
			  };
			

	



	    const handleDepartment = async () => {
	  
			axios.get(API_BASE_URL +'/all_departments_of_incharge', { headers : {
				   'Content-Type': 'application/json',
				   Authorization: `Bearer ${localStorage.getItem("authToken")}`
		   }})
			.then(res1 => setdataval(res1.data))
			.catch(err => console.log(err))
		   };
	  
	  
		   useEffect(() => {
			handleDepartment();
		  }, []);

 const [department, setDepartmentValue] = useState("ALL");
 const [employeeDropdownOptions,setEmployeeDropdownOptions]=useState([]);
 const [employeedet,setEmployeeValue] = useState("ALL");


 const departmentOptions = [
	{ value: "ALL", label: "All Department" },
	...dataval.map(option => ({
		value: String(option.department_id),
		label: option.department_name
	}))
 ];

 const employeeOptions = [
	{ value: "ALL", label: "All Employee" },
	...employeeDropdownOptions.map(option => ({
		value: String(option.user_id),
		label: `${option.first_name} ${option.last_name} (${option.employee_id})`
	}))
 ];

 const selectStyles = {
	control: (base) => ({
		...base,
		minHeight: "28px",
		height: "28px",
		borderRadius: "4px",
		borderColor: "#ced4da",
		boxShadow: "none",
		fontSize: "12px",
		padding: "0 4px",
		"&:hover": { borderColor: "#b3b3b3" }
	}),
	valueContainer: (base) => ({
		...base,
		height: "28px",
		padding: "0 6px",
	}),
	input: (base) => ({
		...base,
		margin: "0px",
		padding: "0px"
	}),
	indicatorsContainer: (base) => ({
		...base,
		height: "28px"
	}),
	menu: (base) => ({
		...base,
		borderRadius: "4px",
		zIndex: 9999
	}),
	option: (base, state) => ({
		...base,
		fontSize: "12px",
		padding: "6px 10px",
		backgroundColor: state.isFocused ? "#f8f9fa" : "white",
		color: "#333"
	})
 };


 const handleFirstDropdownChange = (selected) => {
    const value = selected ? selected.value : "ALL";
    setDepartmentValue(value);
    setEmployeeValue("ALL");

    // Trigger API call based on the selected value
    fetchSecondDropdownOptions(value);
  };


     // Fetch options for the second dropdown
	 const fetchSecondDropdownOptions = async (selectedValue) => {

	  try {
	  
	const response = await fetch(
		  API_BASE_URL + '/showdeptbaseemp/'+selectedValue, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}
		); // Replace with your API URL
  
		const data = await response.json();
		console.log(data);

		setEmployeeDropdownOptions(data); // Assuming the API returns an array of options
	  } catch (error) {
		console.error("Error fetching second dropdown options:", error);
	  }
	};


	  // Handle second dropdown change
	  const handleSecondDropdownChange = (selected) => {
		setEmployeeValue(selected ? selected.value : "ALL");
	  };




  useEffect(()=> {
	axios.get(API_BASE_URL +'/fetchshift', {
		headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
	})

	//.then(res =>console.log(res.data))
	 .then(res => setData(res.data))
	.catch(err => console.log(err));
},[])









const columns = [
  { label: "Employee Id", key: "employee_id", sortable: true },
  { label: "Employee Name", key: "employee_name", sortable: true },
  { label: "Department", key: "department_name", sortable: true },
  { label: "Shift Code", key: "shift_code", sortable: true },
  { label: "Shift Name", key: "shift_name", sortable: true },
  { label: "Shift Date", key: "shift_date", sortable: true },
  { label: "Day", key: "day", sortable: true },
  { label: "Timing", key: "shift_time", sortable: true },
  { label: "Attendance", key: "attendance_time", sortable: false }
];

	return (
		<>
			<style>{`.react-datepicker-popper { z-index: 9999 !important; }`}</style>

			<div>
				<div>
					<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
						<div className="container-fluid">

							<ToastContainer />
						
						</div>
					</div>


					 <div className="section-body mt-3">
										<div className="container-fluid">
											<div className="row clearfix">
												<div className="col-md-12">
													<div className="card">
														<div className="card-header">
															<h3 className="card-title d-flex align-items-center" style={{ color: "#1d3a8a", fontWeight: 600 }}>
																<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 16 16" fill="#1d3a8a" style={{ marginRight: "8px", verticalAlign: "-3px" }}>
																	<path d="M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v1h16V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4zM16 14V5H0v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2m-5.146-5.146-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708.708"/>
																</svg>
																Duty Roster
															</h3>
														</div>
														<div className="card-body">
															 <form onSubmit={handleSubmit} > 
	
																	<div class="row align-items-end">
					
																	<div className="col-md-2 col-sm-6">
																		<div className="form-group mb-2">
																		<label className="form-label">From Date</label>
																		<DatePicker
																			selected={user.start_date ? new Date(user.start_date) : null}
																			onChange={(date) => {
																				const value = date ? date.toLocaleDateString('en-CA') : "";
																				setUser(prev => ({ ...prev, start_date: value }));
																			}}
																			dateFormat="dd-MM-yyyy"
																			placeholderText="Select From Date"
																			className="form-control"
																			wrapperClassName="w-100"
																			showMonthDropdown
																			showYearDropdown
																			dropdownMode="select"
																		/>
																		</div>
																	</div>
					
																	<div className="col-md-2 col-sm-6">
																		<div className="form-group mb-2">
																		<label className="form-label">To Date</label>
																		<DatePicker
																			selected={user.end_date ? new Date(user.end_date) : null}
																			onChange={(date) => {
																				const value = date ? date.toLocaleDateString('en-CA') : "";
																				setUser(prev => ({ ...prev, end_date: value }));
																			}}
																			dateFormat="dd-MM-yyyy"
																			placeholderText="Select To Date"
																			className="form-control"
																			wrapperClassName="w-100"
																			showMonthDropdown
																			showYearDropdown
																			dropdownMode="select"
																			minDate={user.start_date ? new Date(user.start_date) : null}
																		/>
																		</div>
																	</div> 
					
													<div className="col-md-3 col-sm-12">
															<div className="form-group mb-2">
															<label className="form-label">Department</label>
															<Select
																name="department"
																value={departmentOptions.find(opt => opt.value === department) || null}
																onChange={handleFirstDropdownChange}
																options={departmentOptions}
																isSearchable={true}
																placeholder="Select Department"
																styles={selectStyles}
																classNamePrefix="react-select"
															/>
															</div>
														</div>

														<div className="col-md-3 col-sm-12">
															<div className="form-group mb-2">
															<label className="form-label">Employee</label>
															<Select
																name="employeedet"
																value={employeeOptions.find(opt => opt.value === employeedet) || null}
																onChange={handleSecondDropdownChange}
																options={employeeOptions}
																isSearchable={true}
																placeholder="Select Employee"
																isDisabled={employeeDropdownOptions.length === 0}
																styles={selectStyles}
																classNamePrefix="react-select"
															/>
															</div>
														</div>
					
													<div className="col-md-2 col-sm-6">
														<div className="form-group mb-2">
														<label className="form-label" style={{ visibility: "hidden" }}>Get</label>
														<div>
													<button type="submit" className="btn btn-primary">
													GET
												</button>
												</div>
												</div>
												</div>
					
													</div>
					
													
													   
					
																   
					
					
																
						
																
																	
																 </form>
														</div>
													</div>
												</div>
					
											</div>
										</div>
									</div>


										<div className="section-body">
											<div className="container-fluid">
												<div className="tab-content">
													<div className="tab-pane fade show active" id="Employee-list" role="tabpanel">
														<div className="card">
					
															<div className="card-header">
																<div
  className="card-options"
  style={{
    display: "flex",
    alignItems: "center",
    gap: "12px",
  }}
>
  <EntriesSelector
    entriesPerPage={entriesPerPage}
    setEntriesPerPage={setEntriesPerPage}
    setCurrentPage={setCurrentPage}
  />

  {/* 🔽 SEARCH BOX WRAPPER */}
  <div style={{ position: "relative", width: "200px" }}>
    <input
      type="text"
      className="form-control form-control-sm"
      placeholder="Search"
      value={searchTerm}
      onChange={(e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1);
      }}
      style={{
        width: "100%",
        height: "30px",
        fontSize: "13px",
        borderRadius: "4px",
        paddingRight: "28px", // ✅ space for X
      }}
    />

    {searchTerm.length > 0 && (
      <span
        onClick={clearInput}
        style={{
          position: "absolute",
          right: "8px",        // ✅ INSIDE input
          top: "50%",          // ✅ vertically centered
          transform: "translateY(-50%)",
          cursor: "pointer",
          color: "#aaa",
          fontSize: "16px",
          userSelect: "none",
        }}
      >
        ✖
      </span>
    )}
  </div>
</div>
															</div>
					
															{/* <div>
																<DataTable 
																columns={column} 
																data={data}
																customStyles={customStyles}
																pagination 
																highlightOnHover
																responsive
																paginationPerPage={10}
																paginationRowsPerPageOptions={[25,50,100,500]}
																className="table table-striped table-bordered"> 
															</DataTable>
															</div> */}
					
					
					
					
					
					
					
					{/* Loading Spinner */}
					{loading && (
																<div className="card-body">
																<div class="d-flex justify-content-center">
						   <div class="spinner"></div>
						   </div>
						   </div>
						  )}
					
					{!loading && (
															<div className="card-body">
															
																<div className="table-responsive sticky-table-wrap" style={{ maxHeight: "60vh", overflowY: "auto" }}>
							
					
						
						  
								<table className="table table-hover table-striped table-vcenter text-nowrap mb-0 sticky-table">
																		<thead style={{ position: "sticky", top: 0, zIndex: 1 }}>
																			<tr>
					
																			   {columns.map((col) => (
																<th
																	key={col.key}
																	onClick={col.sortable ? () => handleSort(col.key) : null}
																	style={{ cursor: col.sortable ? "pointer" : "default", backgroundColor: "#fff" }}
																>
																	{col.label}
																	{col.sortable && (
																sortConfig.key === col.key
																	? (sortConfig.direction === "asc" ? " ▲" : " ▼")
																	: " ⇅"   // <-- DEFAULT SORT ICON
																)}
																	</th>
																))}
																				
																			</tr>
																		</thead>
																		<tbody>
																		{records.length > 0 ? (
																				filteredData.map((record) => (
																					<tr key={record.employee_id}>
																					<td>{record.employee_id}</td>
																					<td>{record.employee_name}</td>
																					<td>{record.department_name}</td>
																					<td>{record.shift_code}</td>
																					<td>{record.shift_name}</td>
																					<td>{record.shift_date}</td>
																					<td>{record.day}</td>
																					<td>{record.shift_time}</td>
																					<td>{record.attendance_time}</td>
																				</tr>
																				))
																			) : (
																				<tr>
																				<td colSpan="7" style={{ color: 'red', textAlign: 'center',fontWeight: "bold" }}>No records found</td>
																				</tr>
																			)}
					
																
																		</tbody>
																	</table>
																</div>
															
								<Pagination
												currentPage={currentPage}
												totalPages={totalPages}
												onPageChange={setCurrentPage}
												/>	
													
					
															</div> 
					)
					}
														</div>
													</div>
						
												
												</div>
											</div>
										</div>

				</div>
			</div>




		</>
	);

}



const mapStateToProps = (state) => ({
	fixNavbar: state.settings.isFixNavbar,
	statisticsOpen: state.settings.isStatistics,
	statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
	statisticsAction: (e) => dispatch(statisticsAction(e)),
	statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(InchargeShiftInfo);